import React, { useEffect, useRef, useState } from "react";
import { RadioInput } from "../../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/common/ui/Button";
// import PrintExport from "../../../components/common/ui/Export/PrintExport";
import { useReactToPrint } from "react-to-print";
import { history } from "../../../_helpers";
import {
  masterActions,
  staffRequestAction,
  authActions,
} from "../../../_store";
import { useLocation } from "react-router-dom";
import CustomLoader from "../../../components/common/ui/Loader";
import { Popup } from "../../../components/common/ui/NotificationModal/Popup";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import FormHeader from "./FormHeader";
import { StoredProcedures, UserRoleType } from "../../../_helpers/enumerator";
import { handleReviewRequestFormNavigation } from "./ReviewRequestFormNavigator";

const LegalResearchRequest = () => {
  const componentRef = useRef();
  const dispatch = useDispatch();
  const location = useLocation();

  const { YesOrNoOnly } = useSelector((x) => x.dropdownOptions);
  const { user, commonFacilityCode } = useSelector((x) => x.auth);
  const formID = location?.state ? location?.state?.formID : 0;

  // const [formID, setFormID] = useState(location?.state?.formID || 0);
  const formDetails = location?.state ? location?.state?.formDetails : {};

  const sourceFrom = location?.state ? location?.state?.sourceFrom : "";
  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);
  const { ManagementUserID, UserRoleID } = useSelector((x) => x?.auth?.user);

  const RequestFormType = location?.state
    ? location?.state?.RequestFormType
    : 0;

  const {
    legalRequestList,
    closeRequestResponse,
    requestReview,
    indexValue,
    legalRequestFormAccess,
    publicDefenderList,
    staffRequestList,
    staffRequestSearchList,
    staffRequestDefenderSearchList,
    loading,
  } = useSelector((x) => x?.staffRequest);

  const prevFacilityCodeRef = useRef(facilityCode);
  const [errorMessage, setErrorMessage] = useState({});

  //load facility drop down
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, []);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== facilityCode) {
      history.navigate(sourceFrom);
    }
  }, [facilityCode]);

  useEffect(() => {
    if (formID === 0) {
      history?.navigate("StaffRequestList");
      return;
    }
    // dispatch(
    //   staffRequestAction?.getRequestFormAccess({
    //     formID: formID,
    //     FacilityCode: facilityCode,
    //     ManagementUserID: ManagementUserID,
    //   })
    // );
    dispatch(
      staffRequestAction?.getRequestFormAccess({
        ManagementUserID: ManagementUserID,
        // formID: RequestFormType,
        formID:
          RequestFormType > 0
            ? RequestFormType
            : formDetails?.DataList?.[indexValue]?.RequestFormType,
        FacilityCode: facilityCode,
      })
    );
    dispatch(staffRequestAction?.getLegalRequestList(formID));
  }, [
    indexValue,
    formID,
    dispatch,
    ManagementUserID,
    formDetails?.DataList,
    facilityCode,
  ]);

  useEffect(() => {
    if (formID === 0) return;
    if (closeRequestResponse?.IsSucceed === 1) {
      // Insert Management User Activity Log
      dispatch(
        authActions?.ManagementUserActivityLog({
          ManagementUserID: user?.ManagementUserID,
          facilityID: commonFacilityCode ? commonFacilityCode : 0,
          ProcedureName: StoredProcedures?.CloseRequestIRRequestForm,
          UserAction: `Close Legal Research Request Form - In Staff Request Page ( IRRequestFormTypeID - ${formID} )`,
        })
      );

      dispatch(
        staffRequestAction?.UpdateMURequestRead({
          requestID: formID,
          requestFormTypeID: RequestFormType,
          facilityID: facilityCode,
          createdBy: ManagementUserID,
        })
      );
      dispatch(
        masterActions.GetLoadNotificationAlert({
          ManagementUserID: ManagementUserID,
          FacilityID: facilityCode,
        })
      );
      // history?.navigate("/Admin/StaffRequestList");
      showToastNotification(
        "Legal Research Request Form Closed successfully.",
        "success"
      );
      // let i = formDetails?.TotalRecordCount === indexValue ? 0 : indexValue + 1;

      // let NxtFormID = formDetails?.DataList?.[i]?.RequestFormTypeID;

      // dispatch(
      //   staffRequestAction?.getRequestFormAccess({
      //     ManagementUserID: ManagementUserID,
      //     // formID: RequestFormType,
      //     formID:
      //       RequestFormType > 0
      //         ? RequestFormType
      //         : formDetails?.DataList?.[indexValue]?.RequestFormType,
      //     FacilityCode: facilityCode,
      //   })
      // );
      // // dispatch(staffRequestAction?.updateIndexValue(i));
      // dispatch(staffRequestAction?.getLegalRequestList(formID));

      if (requestReview) {
        // if (
        //   UserRoleID === UserRoleType?.PublicDefender ||
        //   UserRoleID === UserRoleType?.PublicDefenderAdmin
        // ) {
        //   //not needed
        //   const searchData = { ...staffRequestDefenderSearchList };
        //   searchData.FacilityID = facilityCode;
        //   searchData.ManagementUserID = ManagementUserID;
        //   searchData.PageNo = 1;
        //   searchData.RowCountPerPage = publicDefenderList?.TotalRecordCount;
        //   dispatch(
        //     staffRequestAction?.PublicDefenderRequestReviewList(searchData)
        //   )
        //     .then((result) => {
        //       if (result?.payload) {
        //         const data = result?.payload;
        //         handleReviewRequestFormNavigation(
        //           "next",
        //           data,
        //           indexValue,
        //           history,
        //           sourceFrom,
        //           dispatch
        //         );
        //       }
        //     })
        //     .catch((err) => {
        //       showToastNotification(err?.message, "error");
        //     });
        // } else {
        //admin
        const searchData = { ...staffRequestSearchList };
        searchData.PageNo = 1;
        searchData.RowCountPerPage = staffRequestList?.TotalRecordCount;
        searchData.FacilityID = facilityCode;
        searchData.ManagementUserID = ManagementUserID;
        dispatch(staffRequestAction?.LoadRequestReviewAllList(searchData))
          .then((result) => {
            if (result?.payload?.DataList?.length > 0) {
              const data = result?.payload;
              handleReviewRequestFormNavigation(
                "next",
                data,
                indexValue,
                history,
                sourceFrom,
                dispatch
              );
            } else {
              history?.navigate("/Admin/StaffRequestList");
            }
          })
          .catch((err) => {
            showToastNotification(err?.message, "error");
          });
        // }
      }
      dispatch(staffRequestAction?.resetForm());
    }
  }, [closeRequestResponse, formID]);

  const handlePrints = useReactToPrint({
    pageStyle: `@media print {
      @page {
       size: A4 portrait;
        margin: 2 !important;
         padding: 2 !important;
      }
body {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      * {
        
        font-size: 16px !important;
      }

      table, th, td {
        border: 2px solid black !important;
      }

      .print-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      .print-date {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  `,
    content: () => componentRef.current,
    onBeforeGetContent: () => { },
  });

  const handleCancelRequest = (e) => {
    e?.preventDefault();
    Popup({
      title: "Message",
      text: `Are you sure you want to close the form?`,
      icon: "warning",
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        dispatch(
          staffRequestAction?.closeRequest({
            formID: formID,
            ManagementUserID: ManagementUserID,
            InmateID: legalRequestList?.InmateID
          })
        ).then(() => {
          if (!requestReview) {
            //     const searchList = {
            //   ...staffRequestSearchList,
            //   PageNo: 1,
            //   RowCountPerPage: 10,
            //   FacilityID: facilityCode,
            // };
            // dispatch(staffRequestAction?.setStaffRequestSearchList(searchList));
            history?.navigate("/Admin/StaffRequestList");
          }
        });
      },
    });
  };


  return (
    <>
      {loading && <CustomLoader />}
      <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 me-3 w-100">
        <FormHeader
          requestReview={requestReview}
          list={formDetails}
          handlePrints={handlePrints}
          source={sourceFrom}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
          RequestFormType={RequestFormType}
        />

        <div className="">
          <form onSubmit={(e) => handleCancelRequest(e)}>
            <div ref={componentRef}>
              <article>
                <h2 style={{ textAlign: "center" }}>
                  Jefferson County Correctional Institute (GA)
                </h2>
                <h4
                  style={{ textAlign: "center", marginTop: "18px" }}
                  className="label-red text-color justify-content-center align-items-center"
                >
                  <i class="fa-solid fa-scale-balanced"></i> Legal Information
                  Request Form
                </h4>
                <div className="col-12">
                  <div className="row  details-legal">
                    <div className="col-6 fs-5 request-form-label">
                      Reference ID
                    </div>
                    <div className="col-6 fw-bold">
                      {legalRequestList?.ReferrenceID}
                    </div>
                  </div>

                  <div className="row  details-legal">
                    <div className="col-6 fs-5 request-form-label">
                      Last Name
                    </div>
                    <div className="col-6 fw-bold">
                      {legalRequestList?.LastName}
                    </div>
                  </div>

                  <div className="row  details-legal">
                    <div className="col-6 fs-5 request-form-label">
                      First Name
                    </div>
                    <div className="col-6 fw-bold">
                      {legalRequestList?.FirstName}
                    </div>
                  </div>

                  <div className="row  details-legal">
                    <div className="col-6 fs-5 request-form-label">
                      Middle Initial
                    </div>
                    <div className="col-6 fw-bold">
                      {legalRequestList?.MiddleName}
                    </div>
                  </div>

                  <div className="row  details-legal">
                    <div className="col-6 fs-5 request-form-label">
                      Inmate ID
                    </div>
                    <div className="col-6 fw-bold">
                      {legalRequestList?.InmateResidentId}
                    </div>
                  </div>

                  <div className="row  details-legal">
                    <div className="col-6 fs-5 request-form-label">
                      Housing Unit
                    </div>
                    <div className="col-6 fw-bold">
                      {legalRequestList?.HousingUint}
                    </div>
                  </div>
                  <div>
                    <div
                      className={`row details-legal ${legalRequestList?.IRRFWhoSentID === 6 ? "border-0" : ""
                        }`}
                    >
                      <div className="col-6 fs-5 mb-0 request-form-label">
                        Who sent you to this prison?
                      </div>
                      <div className="col-6 fw-bold">
                        {legalRequestList?.IRRFWhoSentID === 1
                          ? "Local Law Enforcement Agency"
                          : legalRequestList?.IRRFWhoSentID === 2
                            ? "US Marshall"
                            : legalRequestList?.IRRFWhoSentID === 3
                              ? "ICE/INS"
                              : legalRequestList?.IRRFWhoSentID === 4
                                ? "Georgia DOC"
                                : legalRequestList?.IRRFWhoSentID === 5
                                  ? "Federal Bureau of Prisons"
                                  : "Other (Complete next field)"}
                      </div>
                    </div>
                    {legalRequestList?.IRRFWhoSentID === 6 && (
                      <div className="row border-bottom px-3">
                        <div className="col-6 fs-5 mb-0 request-form-label">
                          Specify 'Other'
                        </div>
                        <div className="col-6 fw-bold">
                          {legalRequestList?.WhoSent}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="row details-legal">
                    <div className="col-6 fs-5 mb-0 request-form-label">
                      Next court date, if known (Month/Day/Year):
                    </div>
                    <div className="col-6 fw-bold">
                      {legalRequestList?.NextCourtDate}
                    </div>
                  </div>

                  <div className="row details-legal">
                    <div className="col-6 fs-5 mb-0 request-form-label">
                      List your current charges
                    </div>
                    <div className="col-6 fw-bold">
                      {legalRequestList?.CurrentCharges}
                    </div>
                  </div>

                  <div className="row details-legal d-flex flex-wrap">
                    <div className=" col-6 fs-5 mb-0 request-form-label">
                      Have you been convicted?
                    </div>
                    <div className="col-6 fw-bold">
                      <RadioInput
                        options={YesOrNoOnly}
                        selectedValue={legalRequestList?.IsConvicted}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row details-legal d-flex flex-wrap">
                    <div className="col-6 fs-5 mb-0 request-form-label">
                      If convicted, have you been sentenced?
                    </div>
                    <div className="col-6 fw-bold">
                      <RadioInput
                        options={YesOrNoOnly}
                        selectedValue={legalRequestList?.IsSentenced}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row details-legal">
                    <div className="col-6 fs-5 mb-0 request-form-label">
                      The matter I am researching has to do with...
                    </div>
                    <div className="col-6 fw-bold">
                      {legalRequestList?.ResearchReason}
                    </div>
                  </div>

                  <div className="row details-legal d-flex flex-wrap">
                    <div className="col-6 fs-5 mb-0 request-form-label">
                      Are you 'Pro Se' in the matter you are researching?
                      <div>('Pro Se' means you are representing yourself.)</div>
                    </div>
                    <div className="col-6 fw-bold">
                      <RadioInput
                        options={YesOrNoOnly}
                        selectedValue={legalRequestList?.IsProSe}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row details-legal d-flex flex-wrap">
                    <div className="col-6 fs-5 mb-0 request-form-label">
                      If not 'Pro Se', do you have a lawyer currently
                      representing you in this matter?
                    </div>
                    <div className="col-6 fw-bold">
                      <RadioInput
                        options={YesOrNoOnly}
                        selectedValue={legalRequestList?.IsLawyerRepresent}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row details-legal d-flex flex-wrap ">
                    <div className="col-6 fs-5 mb-0 request-form-label">
                      The lawyer representing you (if any) is…
                    </div>
                    <div className="col-6 fw-bold">
                      {legalRequestList?.IfIsLawyerRepresent === 0
                        ? "N/A"
                        : legalRequestList?.IfIsLawyerRepresent === 1
                          ? "A Court Appointed Public Defender"
                          : legalRequestList?.IfIsLawyerRepresent === 2
                            ? "A Private Attorney"
                            : ""}
                    </div>
                  </div>

                  <div>
                    <div
                      className={`row details-legal ${legalRequestList?.IRRFJurisdictionReasonID === 7
                        ? "border-0"
                        : ""
                        }`}
                    >
                      <div className="col-6 fs-5 mb-0 request-form-label">
                        What is the jurisdiction of the legal matter you are
                        researching?
                      </div>
                      <div className="col-6 fw-bold">
                        {legalRequestList?.IRRFJurisdictionReasonID === 1
                          ? "Georgia(Criminal)"
                          : legalRequestList?.IRRFJurisdictionReasonID === 2
                            ? "Georgia(Civil)"
                            : legalRequestList?.IRRFJurisdictionReasonID === 3
                              ? "Federal(Criminal)"
                              : legalRequestList?.IRRFJurisdictionReasonID === 4
                                ? "Federal(Civil)"
                                : legalRequestList?.IRRFJurisdictionReasonID === 5
                                  ? "Administrative"
                                  : legalRequestList?.IRRFJurisdictionReasonID === 6
                                    ? "Immigration(ICE)"
                                    : legalRequestList?.IRRFJurisdictionReasonID === 7
                                      ? "Other State (Complete next field)"
                                      : ""}
                      </div>
                    </div>
                    {legalRequestList?.IRRFJurisdictionReasonID === 7 && (
                      <div className="row border-bottom px-3 py-2">
                        <div className="col-sm-6 fs-5 mb-0 request-form-label">
                          Please indicate which 'Other State' if applicable.
                        </div>
                        <div className="col-sm-6 fw-bold">
                          {legalRequestList?.JurisdictionReason}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="p-3">
                    <div className=" fs-5 mb-0 request-form-label">
                      What information would you like to receive? List up to
                      five (5) items:
                      <ol>
                        <li>{legalRequestList?.Information1}</li>
                        <li>{legalRequestList?.Information2}</li>
                        <li>{legalRequestList?.Information3}</li>
                        <li>{legalRequestList?.Information4}</li>
                        <li>{legalRequestList?.Information5}</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </article>
            </div>
            {/* {legalRequestFormAccess?.FormRespond === 1 &&
            legalRequestList?.legalRequestList === 1 && ( */}
            {legalRequestFormAccess?.FormRespond === 1 &&
              // legalRequestList?.legalRequestList === 1 &&
              legalRequestList?.IRRFormOpenStatus !== 0 && (
                <div className="pb-3 d-flex flex-wrap justify-content-center align-items-center">
                  <Button
                    label="Close Request"
                    status="success"
                    type="submit"
                    icon={"a-solid fa-circle-xmark"}
                  />
                </div>
              )}
            {/* )} */}
          </form>
        </div>
      </div>
    </>
  );
};

export default React.memo(LegalResearchRequest);
